import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { Segment } from '../../services/analytics-services/segment';

export const useTrackInsuranceEvent = (eventName: string, source = '') => {
  const planInfo = useSelector(Global.selectSellerPlanInfo);
  const sellerId = useSelector(Global.selectSellerSellerId);

  return useCallback(
    (metadata: Record<string, unknown> = {}) => {
      const payload: Record<string, unknown> = {
        ...metadata,
        sellerId,
        planName: planInfo?.plan?.name,
      };

      if (source) {
        payload.source = source;
      }

      Segment.trackEvent(eventName, payload);
    },
    [eventName, planInfo?.plan?.name, sellerId, source],
  );
};
